import { animate } from 'motion';

const defaultAnimationDuration = 1;
const defaultAnimationDelay = 0;

// export const slideUp = ({
//   element,
//   play
// }: {
//   element: HTMLElement;
//   play?: boolean;
// }) => {
//   const animation = animate(
//     element,
//     {
//       opacity: [0, 1],
//       top: 0
//     },
//     {
//       duration:
//         getComputedStyle(element).transitionDuration !== '0s'
//           ? parseFloat(getComputedStyle(element).transitionDuration)
//           : defaultAnimationDuration,
//       delay:
//         getComputedStyle(element).transitionDelay !== '0s'
//           ? parseFloat(getComputedStyle(element).transitionDelay)
//           : defaultAnimationDelay
//     }
//   );

//   if (play) animation.play();
//   else animation.stop();
// };

export const counter = ({
  element,
  play
}: {
  element: HTMLElement;
  play?: boolean;
}) => {
  const overrideAnimationDuration = element.dataset.animationDuration
    ? parseFloat(element.dataset.animationDuration) / 1000
    : null;

  const overrideAnimationDelay = element.dataset.animationDelay
    ? parseFloat(element.dataset.animationDelay) / 1000
    : null;

  const computedAnimationDuration =
    getComputedStyle(element).transitionDuration !== '0s'
      ? parseFloat(getComputedStyle(element).transitionDuration)
      : defaultAnimationDuration;

  const computedAnimationDelay =
    getComputedStyle(element).transitionDelay !== '0s'
      ? parseFloat(getComputedStyle(element).transitionDelay)
      : defaultAnimationDelay;

  const animationDuration =
    overrideAnimationDuration || computedAnimationDuration;
  const animationDelay = overrideAnimationDelay || computedAnimationDelay;

  const startNumber = parseInt(element.dataset.startNumber);
  const endNumber = parseInt(element.dataset.endNumber);
  const animation = animate(
    progress => {
      const a = endNumber
        ? startNumber +
          Math.round(
            progress *
              (endNumber >= startNumber
                ? endNumber - startNumber
                : startNumber - endNumber)
          )
        : startNumber;

      let finalString = Math.round(a).toString();
      if (element.dataset.useThousandSeparator === 'true') {
        switch (element.dataset.thousandSeparator) {
        case 'comma':
          finalString = Math.round(a).toLocaleString('en-US');
          break;
        case 'dot':
          finalString = Math.round(a).toLocaleString('de-DE');
          break;
        case 'space':
          finalString = Math.round(a)
            .toLocaleString('en-US')
            .replace(/,/g, ' ');
          break;
        default:
          finalString = Math.round(a).toLocaleString('en-US');
          break;
        }
      }

      element.innerText = finalString;
    },
    {
      duration: animationDuration,
      delay: animationDelay
    }
  );
  if (play) animation.play();
  else animation.stop();
};
